import React from "react";
import PropTypes from "prop-types";
import "./index.css";
import { useButtonClass } from "./styles";
import cx from "../../utils/class-names";

const COLORS = ["default", "primary", "secondary", "success", "info", "warning", "danger"];
const VARIANTS = ["outline", "link", "solid"];
const SIZES = ["xs", "sm", "md", "lg", "xl", "2xl"];

const Button = React.forwardRef(function Button(props, ref) {
  const { 
    className = "", 
    variant, 
    rounded, 
    size, 
    color, 
    disabled, 
    icon = null, 
    children, 
    dataTitle, 
    dataTooltipFull, 
    classNames = {}, 
    ...restProps 
  } = props;

  const classes = useButtonClass({
    disabled,
    variant,
    rounded,
    size,
    color,
    className,
    icon,
  });

  if (dataTooltipFull) {
    return (
      <div className={cx("button-wrapper", classNames.wrapper)}>
        <button 
          ref={ref} 
          data-title={dataTitle} 
          disabled={disabled} 
          className={cx("button", classes)} 
          type="button" 
          {...restProps}
        >
          {icon}
          <span className={cx(icon && "ml-1.5 inline-flex")}>{children}</span>
        </button>
        <div className={cx("custom-tooltip", classNames.tooltip)}>
          {dataTooltipFull.split("\n").map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <button 
      ref={ref} 
      data-title={dataTitle} 
      disabled={disabled} 
      className={cx("button", classes)} 
      type="button" 
      {...restProps}
    >
      {icon}
      <span className={cx(icon ? "ml-1.5 inline-flex" : "w-full")}>{children}</span>
    </button>
  );
});

Button.defaultProps = {
  variant: "solid",
  size: "md",
  color: "default",
  disabled: false,
};

Button.propTypes = {
  variant: PropTypes.oneOf(VARIANTS),
  size: PropTypes.oneOf(SIZES),
  color: PropTypes.oneOf(COLORS),
  disabled: PropTypes.bool,
  dataTitle: PropTypes.string,
  dataTooltipFull: PropTypes.string,
};

export default Button;